<template>
  <div class="companies" >
    <s-table class="companies__table no-align"
      :fields="fields"
      :items="companies"
      :busy="loading"
    >
      <template #head(check)>
        <div class="companies__check-wrapper">
          <b-form-checkbox @click.native.stop :checked="allSelected" @change="toggleAll"/>
        </div>
      </template>
      <template #cell(check)="data">
        <b-form-checkbox v-model="data.item.selected" />
      </template>
    </s-table>
  </div>
</template>

<script>
import { uniqBy } from 'lodash';
import ProfileEditService from '@/domain/services/generalPanel/adminPanel/profile/profileEditService';

export default {
  name: 'Companies',
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    select: true,
    loading: true,
    companies: [],
  }),
  computed: {
    fields() {
      return [
        { key: 'check', class: 'companies__cell-check' },
        {
          key: 'name',
          class: 'companies__cell-company-name',
          label: this.$t('profile-manager.editing.companies.company'),
        },
      ];
    },
    allSelected() {
      return this.companies.length > 0 && this.companies.every(it => it.selected);
    },
    selection() {
      return this.companies.filter(it => it.selected);
    },
  },
  created() {
    this.getCompanies();
  },
  methods: {
    toggleAll(checked) {
      this.companies.forEach((it) => {
        it.selected = checked;
      });
    },
    handleSelectedCompanies() {
      if (!this.profile.companies) return;
      this.profile.companies.forEach(({ id: companyId }) => {
        const company = this.companies.find(it => it.id === companyId);
        if (company) {
          company.selected = true;
        }
      });
    },
    getCompanies() {
      ProfileEditService.getCompaniesProfile({
        profileId: this.profile.id,
        parentProfileId: this.profile.parentProfileId,
      }).then((data) => {
        this.loading = false;
        this.companies = data;
        this.handleSelectedCompanies();
        this.setInitialValues();
      }).finally(() => {
        this.loading = false;
      });
    },
    setInitialValues() {
      this.$emit('setInitialValues:companies', this.companies.filter(company => company.selected));
    },
  },
  watch: {
    selection(items) {
      if (!this.loading) {
        const preservedItems = this.profile.companies.filter(oldItem => !this.companies
          .some(currentItem => currentItem.id === oldItem.id));
        this.profile.companies = uniqBy([...preservedItems, ...items], 'id');
      }
    },
  },
};
</script>
<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .companies
    &__table ::v-deep
      tbody
        display: block
        max-height: 430px
        overflow: auto
      tbody, thead
        tr
          display: table
          width: 100%
          table-layout: fixed
    &__loader
      font-size: 2em
      margin-bottom: 1em
    &__check-wrapper
      display: flex
    ::v-deep &__cell
      &-check
        width: 40px
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>
